import { render } from "./AksiLogin.vue?vue&type=template&id=13d2eac4"
import script from "./AksiLogin.vue?vue&type=script&lang=js"
export * from "./AksiLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__